

































































































































import {ratingApi} from '@/api/RatingApi';
import {tournamentsApi} from '@/api/TournamentsApi';
import {filterMatchColumns} from '@/helpers';
import he from 'he';
import {reportsService} from '@/services/ReportsService';
import {
  startWith,
  switchMap,
  map,
  shareReplay,
  filter,
} from 'rxjs/operators';
import {combineLatest, from, asyncScheduler, merge, iif, of} from 'rxjs';
import {Prop, Component, Vue} from 'vue-property-decorator';
import UserLinks from '../../components/common/UserLinks.vue';
import BlankLoader from '../../components/common/BlankLoader.vue';
import QuickAccess from '../../components/rating/QuickAccess.vue';
import UnconfirmedReports from '../../components/rating/UnconfirmedReports.vue';
import RatingChange from '../../components/common/RatingChange.vue';
import RandomSign from '../../components/common/RandomSign.vue';
import DataFilter from '../../components/common/DataFilter.vue';
import DataTable from '../../components/common/DataTable.vue';
import CollapsibleTable from '../../components/common/CollapsibleTable.vue';
import UserTournaments from '../../components/rating/UserTournaments.vue';
import {
  generateLangSubscriptions,
  observeFieldAsUIInput,
  observeProp,
  observeRouteParam,
  watchAsLoadedObservable,
} from '@/components/observe';
import UserUnconfirmedReports from '@/components/rating/UserUnconfirmedReports.vue';
import {Route} from 'vue-router';
import FractionIcon from '@/components/common/FractionIcon.vue';
import HeroIcon from '@/components/common/HeroIcon.vue';
import FlagIcon from '@/components/common/FlagIcon.vue';
import GameResultIcon from '@/components/common/GameResultIcon.vue';
import {forumApi} from '@/api/ForumApi';

@Component<UserRatingView>({
  components: {
    GameResultIcon,
    FlagIcon,
    UserUnconfirmedReports,
    UserTournaments,
    UserLinks,
    BlankLoader,
    QuickAccess,
    UnconfirmedReports,
    RatingChange,
    RandomSign,
    DataFilter,
    DataTable,
    CollapsibleTable,
    FractionIcon,
    HeroIcon,
  },
  subscriptions() {
    const $route$ = observeProp<Route>(this, '$route');
    const lang$ = observeRouteParam<string>($route$, 'lang');
    const userId$ = merge(
      iif(
        () => !this.userId,
        from(tournamentsApi.getCurrentTournamentUserInfo$(), asyncScheduler).pipe(map((x: any) => x.user_id)),
        of(this.userId),
      ),
      observeProp(this, 'userId'),
    ).pipe(
      filter((x: any) => !!x),
    );

    const userReports$ = combineLatest(
      userId$,
      lang$,
    ).pipe(
      switchMap(([userId, lang]) => from(reportsService.getUserReports$(userId, lang), asyncScheduler)),
    );
    const userProfile$ = userId$.pipe(
      switchMap((x) => from(ratingApi.getUserProfile$(x), asyncScheduler)),
      shareReplay(1),
    );

    return Object.assign(generateLangSubscriptions(lang$), {
      currentUser: userProfile$,
      currentUserId: userId$,
      username: userProfile$.pipe(switchMap((x: any) => of(he.decode(x.username)))),
      unconfirmedReports: userReports$.pipe(map((x: any) => x.filter((y: any) => !y.is_confirmed))),
      confirmedReports: combineLatest(
        userReports$,
        observeFieldAsUIInput(this, 'reportsFilter'),
      ).pipe(
        map(([reports, reportsFilter]: any) => reports.filter((x: any) => this.filterMatch(x, reportsFilter))),
        map((x: any) => x.filter((y: any) => y.is_confirmed)),
      ),
      isUserProfileLoaded: combineLatest(
        userProfile$,
        userId$,
      ).pipe(
        switchMap(([userProfile, userId]: any) => of(userProfile.user_id === parseInt(userId, 10))),
        startWith(false),
      ),
      isConfirmedReportsLoaded: merge(
        watchAsLoadedObservable(this, 'unconfirmedReports'),
        userId$.pipe(switchMap(() => of(false))),
      ),
      isUnconfirmedReportsLoaded: merge(
        watchAsLoadedObservable(this, 'confirmedReports'),
        userId$.pipe(switchMap(() => of(false))),
      ),
    });
  },
})
export default class UserRatingView extends Vue {
  public reportsColumns = [
    {name: 'date', title: 'game_date', width: '5.88%'},
    {name: 'player', title: 'player', width: '5.88%'},
    {name: 'player_color', title: 'color', width: '5.88%'},
    {name: 'player_fraction', title: 'fraction', width: '5.88%'},
    {name: 'player_start_hero', title: 'start_hero', width: '5.88%'},
    {name: 'player_main_hero', title: 'main_hero', width: '5.88%'},
    {name: 'result', title: 'result', width: '5.88%'},
    {name: 'rival', title: 'rival', width: '5.88%'},
    {name: 'rival_color', title: 'color', width: '5.88%'},
    {name: 'rival_fraction', title: 'fraction', width: '5.88%'},
    {name: 'rival_start_hero', title: 'start_hero', width: '5.88%'},
    {name: 'rival_main_hero', title: 'main_hero', width: '5.88%'},
    {name: 'template', title: 'template', width: '5.88%'},
    {name: 'time', title: 'time', width: '5.88%'},
    {name: 'player_rating_change', title: 'player_rating_change', width: '5.88%'},
    {name: 'rival_rating_change', title: 'rival_rating_change', width: '5.88%'},
    {name: 'links', title: 'links', width: '5.88%'},
  ];
  public reportsFilter = '';

  @Prop() public userId!: number;

  get forumProfileLink() {
    return forumApi.getUserProfileUrl(this.userId);
  }

  public filterMatch(report: any, reportFilter: any) {
    return filterMatchColumns(report, reportFilter, [
      'game_date',
      'player_fraction',
      'player_start_hero',
      'player_main_hero',
      'result',
      'rival_fraction',
      'rival_start_hero',
      'rival_main_hero',
      'template',
      'game_time',
      'player1_username',
      'player2_username',
    ]);
  }
}
